import { render, staticRenderFns } from "./LinkToggle.vue?vue&type=template&id=2efb0bf0&"
import script from "./LinkToggle.vue?vue&type=script&lang=js&"
export * from "./LinkToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports